import AkButton from '@atlaskit/button';
import { asInstrumentedButton } from './asInstrumentedButton';

export default asInstrumentedButton(AkButton);
